import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * /peak-home/* is static HTML from vite-plugin-peak-home (not React).
 * Client-side navigations must hard-reload so Vite serves the file.
 */
export function PeakHomeStaticRedirect() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const base = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');
    const root = `${base}/peak-home`;
    const isRoot = pathname === root || pathname === `${root}/`;
    const target = isRoot ? `${root}/` : pathname;
    window.location.replace(`${target}${search}${hash}`);
  }, [pathname, search, hash]);

  return (
    <p className="text-sm text-charcoal-600 p-4" role="status">
      Opening Peak Home Hub…
    </p>
  );
}
